import React from "react"

import { PointMarker, LineMarker, LinesPointsMarker, BoxMarker } from "./KeyMarkers"

export default function ObservationKeyMarker(props) {
  const { style } = props

  if (style === "line") {
    return <LineMarker {...props} />
  } else if (style === "linespoints") {
    return <LinesPointsMarker {...props} />
  } else if (style === "box") {
    return <BoxMarker {...props} />
  } else {
    return <PointMarker {...props} />
  }
}
